export default "__VITE_ASSET__GyRvZTX___"